import { useState, useEffect, useRef } from "react";
import ChatSidebarPortal from "./portals/ChatSidebarPortal";
import WikiSidebarPortal from "./portals/WikiSidebarPortal";
import FeedSidebarPortal from "./portals/FeedSidebarPortal";
import HomeSidebarPortal from "./portals/HomeSidebarPortal";
import GraphSidebarPortal from "./portals/GraphSidebarPortal";
import ReportsSidebarPortal from "./portals/ReportsSidebarPortal";
import EmptyPortal from "./portals/EmptyPortal";
import PopUpSearch from "../../Panels/PopUpSearch";
import useSharedSearchItems from "../Search/useSharedSearchItems";
import { useCompanyContext } from "../../../context"; // adjust path as needed

const SidebarPortals = () => {
  useSharedSearchItems();
  const [triggerReload, setTriggerReload] = useState(false);
  const { showAddCompany, setShowAddCompany, refreshCompanies, companyKey } =
    useCompanyContext();

  // When PopUpSearch closes, refresh the company list so
  // CompanySelect immediately shows the newly added company
  const prevShowRef = useRef(showAddCompany);
  useEffect(() => {
    const wasOpen = prevShowRef.current;
    prevShowRef.current = showAddCompany;
    if (wasOpen && !showAddCompany) {
      refreshCompanies();
    }
  }, [showAddCompany]);

  return (
    <>
      {/*
        key={companyKey} on each company-scoped portal forces a full remount
        whenever the selected company changes — re-running all data fetching
        hooks even if the user isn't currently on that page.
      */}
      <ChatSidebarPortal key={`chat-${companyKey}`} />
      <WikiSidebarPortal
        key={`wiki-${companyKey}`}
        onAddCompany={() => setShowAddCompany(true)}
        triggerReload={triggerReload}
      />
      <FeedSidebarPortal key={`feed-${companyKey}`} />
      <HomeSidebarPortal key={`home-${companyKey}`} />
      <GraphSidebarPortal key={`graph-${companyKey}`} />
      <ReportsSidebarPortal key={`reports-${companyKey}`} />
      <EmptyPortal slotId="explorer-portal-slot" />
      {showAddCompany && (
        <PopUpSearch
          setAddCompanyMenu={setShowAddCompany}
          triggerThreadReload={triggerReload}
          setTriggerThreadReload={setTriggerReload}
        />
      )}
    </>
  );
};

export default SidebarPortals;
